function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6666 16.8884C23.6666 21.135 21.1349 23.6667 16.8883 23.6667H15.4999C14.8583 23.6667 14.3333 23.1417 14.3333 22.5V15.7684C14.3333 15.4534 14.5899 15.1851 14.9049 15.1851L16.9583 15.1501C17.1216 15.1384 17.2616 15.0217 17.2966 14.8584L17.7049 12.6301C17.7399 12.4201 17.5766 12.2217 17.3549 12.2217L14.8699 12.2567C14.5432 12.2567 14.2866 12.0001 14.2749 11.6851L14.2283 8.82671C14.2283 8.64004 14.3799 8.47672 14.5782 8.47672L17.3782 8.43004C17.5766 8.43004 17.7283 8.27839 17.7283 8.08006L17.6816 5.28003C17.6816 5.0817 17.5299 4.93004 17.3316 4.93004L14.1816 4.97672C12.2449 5.01172 10.7049 6.59837 10.7399 8.53504L10.7983 11.7434C10.8099 12.07 10.5533 12.3267 10.2266 12.3384L8.82658 12.3617C8.62825 12.3617 8.4766 12.5134 8.4766 12.7117L8.5116 14.9284C8.5116 15.1267 8.66325 15.2784 8.86158 15.2784L10.2616 15.2551C10.5883 15.2551 10.8449 15.5117 10.8566 15.8267L10.9616 22.4767C10.9732 23.1301 10.4482 23.6667 9.7949 23.6667H7.11158C2.86492 23.6667 0.333252 21.135 0.333252 16.8767V7.1117C0.333252 2.86504 2.86492 0.333374 7.11158 0.333374H16.8883C21.1349 0.333374 23.6666 2.86504 23.6666 7.1117V16.8884Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 11.9999,
  y1: 0.333374,
  x2: 12,
  y2: 39.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055445"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10F0C6",
  stopOpacity: 0
})));

function SvgFacebookTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookTwo);
export default __webpack_public_path__ + "static/media/facebookTwo.549c8a53f6f64edaf0dd854514fe8615.svg";
export { ForwardRef as ReactComponent };